const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const liveBaseUrl = trimTrailingSlash(process.env.REACT_APP_API || "");
const analyzerBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_API_ANALYZER || ""
);

export const apiConfig = {
  liveBaseUrl,
  analyzerBaseUrl,
};
